import React, { useEffect, useState } from 'react';
import {
  Box, Typography, CircularProgress, Container, Button, Dialog,
  DialogTitle, DialogContent, DialogActions
} from '@mui/material';
import { QRCodeCanvas } from 'qrcode.react';
import axios from 'axios';
import MachineSelectDropdown from '../components/MachineSelectDropdown';
import { API_BASE } from '../config';

const RESET_API = (uid) => `${API_BASE}/zts/admin/v1.0/reset/locker/${uid}/`;

const ResetLocker = () => {
  const [selectedMachine, setSelectedMachine] = useState('');
  const [locationName, setLocationName] = useState('');
  const [qrData, setQrData] = useState('');
  const [expiry, setExpiry] = useState(null);
  const [countdown, setCountdown] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!expiry) return;

    const interval = setInterval(() => {
      const secondsLeft = Math.max(0, Math.floor((new Date(expiry).getTime() - Date.now()) / 1000));
      setCountdown(secondsLeft);
    }, 1000);

    return () => clearInterval(interval);
  }, [expiry]);

  const handleGenerateQR = async () => {
    if (!selectedMachine) return;
    setLoading(true);
    setError(false);
    setQrData('');
    setExpiry(null);

    try {
      const res = await axios.post(RESET_API(selectedMachine));
      if (res.data.success) {
        setQrData(res.data.data);
        setExpiry(res.data.expiry);
      } else {
        setError(true);
      }
    } catch (err) {
      console.error('Error fetching QR:', err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Typography variant="h5" sx={{ mb: 2 }}>Reset Locker</Typography>

      <MachineSelectDropdown
        selectedMachine={selectedMachine}
        setSelectedMachine={setSelectedMachine}
        setLocationName={setLocationName}
      />

      <Box sx={{ mb: 2 }}>
        <Button
          variant="contained"
          onClick={handleGenerateQR}
          disabled={!selectedMachine || loading}
        >
          Generate QR
        </Button>
      </Box>

      {loading && (
        <Box sx={{ textAlign: 'center', mt: 2 }}>
          <CircularProgress />
          <Typography>Loading QR Code...</Typography>
        </Box>
      )}

      {error && (
        <Typography color="error">Failed to generate QR code. Please try again.</Typography>
      )}

      {qrData && (
        <Box sx={{ textAlign: 'center', mt: 3 }}>
          <QRCodeCanvas value={qrData} size={200} />
          {expiry && (
            <>
              <Typography sx={{ mt: 2 }}>QR Code expires at: <strong>{new Date(expiry).toLocaleString()}</strong></Typography>
              <Typography>Countdown: <strong>{countdown === 0 ? 'QR EXPIRED' : `${countdown} seconds`}</strong></Typography>
            </>
          )}
        </Box>
      )}
    </Container>
  );
};

export default ResetLocker;